import axios from 'api/axios'
import { ClientWhatsAppDetails } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

export const getClientWhatsAppDetails = async (
	id: string
): Promise<ClientWhatsAppDetails> => {
	try {
		const { data } = await axios.get<ClientWhatsAppDetails>(`v1/wa/profile/${id}`)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getClientWhatsAppDetails
